/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Screenshot_NextInputs */

const en_directory_detail_screenshot_next = /** @type {(inputs: Directory_Detail_Screenshot_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next screenshot`)
};

const zh_directory_detail_screenshot_next = /** @type {(inputs: Directory_Detail_Screenshot_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一张截图`)
};

/**
* | output |
* | --- |
* | "Next screenshot" |
*
* @param {Directory_Detail_Screenshot_NextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_screenshot_next = /** @type {((inputs?: Directory_Detail_Screenshot_NextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Screenshot_NextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_screenshot_next(inputs)
	return zh_directory_detail_screenshot_next(inputs)
});
export { directory_detail_screenshot_next as "directory.detail.screenshot_next" }